export class Adresse {
	ADR_ID: number | null
	USR_ID: number | null;
	ADR_ADRESSE_1: string;
	ADR_CP: string;
	ADR_VILLE: string;
	PYS_CODE: string;
	// Other Properties
	[key: string]: any;

	// Constructor
	constructor(
		ADR_ID: number | null = null,
		USR_ID: number | null = null,
		ADR_ADRESSE_1: string = "",
		ADR_CP: string = "",
		ADR_VILLE: string = "",
		PYS_CODE: string = ""
	) {
		this.ADR_ID = ADR_ID;
		this.USR_ID = USR_ID;
		this.ADR_ADRESSE_1 = ADR_ADRESSE_1;
		this.ADR_CP = ADR_CP;
		this.ADR_VILLE = ADR_VILLE;
		this.PYS_CODE = PYS_CODE;
	}
}
